import { View } from 'rune-ts';
import { CreatorSearchCard } from '@services/MarppleShop/renderApp/components/cells/CreatorSearchCard/CreatorSearchCard.ts';
import { BecomeFanButtonController } from '@services/MarppleShop/renderApp/components/cells/CreatorMainProfile/controllers/BecomeFanController.ts';
import { goLogin } from '@services/MarppleShop/shared/util/goLogin.ts';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';

export class SearchPageController {
  constructor(private readonly layout_options: BaseLayoutOptions) {}

  public delegateFanLetterButtonClick(view: View) {
    view.delegate(CreatorSearchCard.FanButtonClickEvent, CreatorSearchCard, async (e, Card) => {
      if (this.layout_options.user?.id) {
        const { id, is_liked } = e.detail;

        Card.setLikeState(!!is_liked);

        BecomeFanButtonController.postLike({ is_liked: !!is_liked, store_id: id }, () => {
          Card.setLikeState(!is_liked);
        });
      } else {
        await goLogin();
      }
    });
  }
}
